<template>
    <div>
      <b-row>
        <b-col sm="5" lg="5">
          <div class="dashboard-chart">
            <h4>Presupuestos x Tipo</h4>
            <p class="description">Últimos 12 meses</p>
            <ranking ref="ranking"></ranking>
            <label class="description">Ranking por Cantidad de Presupuestos Confirmados</label>
          </div>
        </b-col>
        <b-col sm="7" lg="7">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="resultadosPresupuestosTipos" 
              :fields="resultadosPresupuestosTiposFields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>
            <template v-slot:cell(color)="data">
                <div class="color-reference" :style='"background-color: " + getColor(data.item) + ";"'></div>              
            </template>
            <template v-slot:cell(pjeParticipacion)="data">
              {{ data.item.pjeParticipacion | porcentaje }}
            </template>
          </b-table>
        </b-col>
      </b-row>

      <app-mensaje
        :modalMsj="modalMsj"
        :modalMensaje="modalMensaje"
        @okAction="okAction"
        @hiddenAction="hiddenAction">
      </app-mensaje>
    </div>
</template>

<script>
import Ranking from '../../charts/Pie';
import Mensaje from  '../../shared/msjModal.vue';
import { msjModal } from '../../../mixins/modalDialogs'

export default {
  components: {
    Ranking,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],

data() {
    return {
      key: 0,
      tableBusy: false,

      resultadosPresupuestosTipos: [],
      resultadosPresupuestosTiposFields: [
        { 
          key: 'color',
          label: 'Ref.'
        },
        { key: 'tipoPresupuesto' },
        { 
          key: 'cantidad',
          class: 'text-right'
        },
        { 
          key: 'pjeParticipacion',
          class: 'text-right'
        },
      ],
    }
  },
  created() {
  },
  methods: {
    getResultados() {
      this.$store.dispatch('indicadoresCuentas/getResultadosPresupuestosTipos')
        .then(() => {
          this.resultadosPresupuestosTipos = this.$store.getters['indicadoresCuentas/resultadosPresupuestosTipos'];
          let labels = this.$store.getters['indicadoresCuentas/resultadosPresupuestosTiposLabels'];
          let colors = this.$store.getters['indicadoresCuentas/resultadosPresupuestosTiposColors'];
          let data = this.$store.getters['indicadoresCuentas/resultadosPresupuestosTiposData'];

          this.$refs.ranking.render(labels, colors, data, false);
        });
    },
    getColor(item) {
      return item.color;
    },
  }
}
</script>

<style>
</style>


